export default function getCSRFToken() {
  if (typeof window === 'object') {
    // running in browser
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.getAttribute('content') : ''
  }
  return ''
}
